import { useNavigate, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function Legal() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#050505]" data-testid="legal-page">
      <header className="sticky top-0 z-50 glass-darker border-b border-white/5">
        <div className="max-w-3xl mx-auto px-4 py-4 flex items-center gap-4">
          <button onClick={() => navigate(-1)} className="text-zinc-400 hover:text-white" data-testid="legal-back-btn">
            <ArrowLeft size={20} />
          </button>
          <h1 className="font-heading text-xl font-bold text-white">Legal</h1>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 py-8 space-y-4">
        {[
          { to: "/legal/terms", label: "Terms of Service", desc: "Purchase terms, account rules, and usage policies" },
          { to: "/legal/privacy", label: "Privacy Policy", desc: "What data we collect, how we use it, and your rights" },
          { to: "/legal/disclaimer", label: "Financial Disclaimer", desc: "Educational content only — not financial advice" },
          { to: "/legal/fund-a-family", label: "Fund a Family Terms", desc: "How the community funding program works" },
          { to: "/legal/coppa", label: "Children's Privacy (COPPA)", desc: "How we handle data for users under 13" },
        ].map((item) => (
          <Link key={item.to} to={item.to}
            className="block card-dark p-5 hover:border-[#F7931A]/30 transition-colors"
            data-testid={`legal-link-${item.to.split('/').pop()}`}>
            <p className="text-white font-medium">{item.label}</p>
            <p className="text-zinc-500 text-sm mt-0.5">{item.desc}</p>
          </Link>
        ))}
      </main>
    </div>
  );
}
